import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../../ui/Dialog/DialogActions";
import AddRoomResourceForm from "../AddRoomResourceForm";
import Button from "../../../../../../../ui/Button";

const styles = theme => ({
  blackSpan: {
    fontSize: "12px",
    lineHeight: "16px",
    color: "#000"
  },
  dialog: {
    width: "550px"
  }
});

const AddRoomModal = ({
  open,
  handleClose,
  createInventoryItem,
  createdInventoryItem,
  roomInfo,
  isCreatingRoom,
  resourceId,
  createdRoom,
  classes
}) => {
  const [formData, updateFormData] = React.useState(null);

  const onConfirm = () => {
    createInventoryItem(formData);
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  useEffect(() => {
    if (createdInventoryItem && createdInventoryItem.success) {
      updateFormData(null);
      handleClose();
    }
  }, [createdInventoryItem]);

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>
          <span>{`Добавить новый ресурс в `}</span>
          <span
            className={classes.blackSpan}
          >{`${roomInfo.data.name}` + (roomInfo.info.depName ? (`, ${roomInfo.info.depName}`) : ``) + (roomInfo.info.orgName ? (`, ${roomInfo.info.orgName}`) : ``)}</span>
        </DialogTitle>
        <DialogContent>
          <AddRoomResourceForm
            roomInfo={roomInfo}
            onFormChange={updateFormData}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isCreatingRoom}
            disabled={isCreatingRoom}
            onClick={() => onConfirm()}
            color="green"
          >
            Добавить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(withRouter(AddRoomModal));
